import styled from 'styled-components';

// Ảnh trong nội dung CMS: giữ CSS thường để style inline từ CMS vẫn được ưu tiên
export const PolicyWrapper = styled.div`
  article img {
    height: 100%;
    width: 100%;
  }
`;
